import { Injectable } from '@angular/core';
import { InveniasDataSourceApiService } from 'datasource-service-lib';
import { BLANK_TYPE, FilterLabel, IDocumentType, IDocumentTypeService } from 'document-type-picker-lib';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class InveniasDocumentTypeService implements IDocumentTypeService {
  constructor(private apiService: InveniasDataSourceApiService) {}

  getDocumentTypeLabel(): string {
    return 'document';
  }

  getDocumentTypes(entityType: string, filterLabel?: FilterLabel): Observable<IDocumentType[]> {
    return this.apiService.settings('DocumentType').pipe(
      map((response) => {
        const documentTypes = response.Settings.ItemReferences.map((ir: { Id: string; ItemDisplayText: string }) => ({
          id: ir.Id,
          label: ir.ItemDisplayText,
        }));
        documentTypes.push(BLANK_TYPE);
        return documentTypes;
      })
    );
  }

  getRecordTerm(): string {
    return 'record';
  }
}
